export default __webpack_public_path__ + "static/media/arrow.a7f5a83a.svg";